import React, { useState } from 'react'
import { SecondaryButton } from '@/features/survey-builder/Tabs/CustomButton'
import { Outlet, useLocation } from 'react-router-dom'
import Calcom from '@/components/cal.com/Calcom'
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { CircleHelp } from 'lucide-react'

const OnboardingLayout: React.FC = () => {
    const [isBookingOpen, setIsBookingOpen] = useState(false)
    const location = useLocation()

    const handleScheduleClick = () => {
        setIsBookingOpen(true)
    }

    return (
        <div className="min-h-screen bg-[#F1F1F1] flex flex-col">
            <header className="w-full flex items-center justify-between px-8 py-4 h-[100px]">
                <img
                    src="/compra-text.svg"
                    alt="Compra Logo"
                    className="max-h-content"
                    loading="lazy"
                />
                {location.pathname !== '/book-a-call' && (
                    <SecondaryButton
                        icon={<CircleHelp size={16} />}
                        text="Need help setting up? Schedule a call"
                        onClick={handleScheduleClick}
                    />
                )}
            </header>
            <div className="container mx-auto bg-[#F1F1F1] h-[calc(100vh-100px)]">
                <Outlet />
            </div>

            <Dialog open={isBookingOpen} onOpenChange={setIsBookingOpen}>
                <DialogContent className="max-w-[800px] h-[650px] p-0">
                    <DialogHeader className="px-6 py-6">
                        <DialogTitle>Schedule a Call</DialogTitle>
                    </DialogHeader>
                    <div className="flex flex-col h-[550px]">
                        <Calcom
                            onBookingSuccess={() => {
                                setIsBookingOpen(false)
                            }}
                        />
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default OnboardingLayout
